import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';
import { AuthService } from '../_shared/services/auth.service';
import { BlockUI, BlockUIModule, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-logout',
  standalone: true,
  imports: [BlockUIModule],
  templateUrl: './logout.component.html',
  styleUrl: './logout.component.scss'
})
export class LogoutComponent implements OnInit {
  @BlockUI() blockUI!: NgBlockUI;

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute) {
  }

  async ngOnInit(): Promise<void> {
    const isSessionExpired = await this.isSessionExpired();
    if (isSessionExpired) {
      this.router.navigate(['/authenticate']);
    } else {
      this.logout();
    }
  }

  async isSessionExpired(): Promise<boolean> {
    const params = await firstValueFrom(this.route.queryParams);
    const result: boolean = params['isSessionExpired'] && params['isSessionExpired'] === 'true';
    return result;
  }

  async logout(): Promise<void> {
    this.blockUI.start();
    this.authService.logout();
    setTimeout(() => {
      this.blockUI.stop();
      window.location.reload();
    }, 1000)
  }
}
